import { render, staticRenderFns } from "./LoginBody.vue?vue&type=template&id=133de670&scoped=true&"
import script from "./LoginBody.vue?vue&type=script&lang=ts&"
export * from "./LoginBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133de670",
  null
  
)

export default component.exports